// import axios from 'axios';

// const axiosInstance = axios.create({
//     baseURL: "https://powermanindia.com/backendApi/api/",
//     baseIMG: "https://powermanindia.com/backendApi/uploads/",
//     timeout: 10000,
//     headers: {
//         'Accept': 'application/json',
//     },
// });

// // Request Interceptor
// axiosInstance.interceptors.request.use(config => {
//     const token = localStorage.getItem('authToken');
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }

//     // ✅ Only set content-type if data exists and is not FormData
//     if (config.data && !(config.data instanceof FormData)) {
//         config.headers['Content-Type'] = 'application/json';
//     }

//     return config;
// }, error => {
//     return Promise.reject(error);
// });

// // Response Interceptor
// axiosInstance.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response && error.response.status === 401) {
//             console.error("Unauthorized! Redirecting to login...");
//         }
//         return Promise.reject(error);
//     }
// );

// export default axiosInstance;





import axios from 'axios';

const axiosInstance = axios.create({

    baseURL: "https://powermanindia.com/backendApi/api/",
    baseIMG: "https://powermanindia.com/backendApi/uploads/",
    timeout: 10000, // 10 seconds
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Optional: Request interceptor (e.g., to add auth token)
axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem('authToken'); // Example: get token
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// Optional: Response interceptor (e.g., to handle 401 errors)
axiosInstance.interceptors.response.use(response => response, error => {
    if (error.response && error.response.status === 401) {
        console.error("Unauthorized! Redirecting to login...");
        // Optionally: dispatch a logout action, redirect to login page
    }
    return Promise.reject(error);
});

export default axiosInstance;



// import axios from 'axios';

// const axiosInstance = axios.create({

//     baseURL: "https://powermanindia.com/backendApi/api/",
//     baseIMG: "https://powermanindia.com/backendApi/uploads/",
//     timeout: 10000,
//     headers: {
//         'Accept': 'application/json',
//     },
// });

// axiosInstance.interceptors.request.use(config => {
//     const token = localStorage.getItem('authToken');
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// }, error => {
//     return Promise.reject(error);
// });

// axiosInstance.interceptors.response.use(response => response, error => {
//     if (error.response && error.response.status === 401) {
//         console.error("Unauthorized! Redirecting to login...");
//     }
//     return Promise.reject(error);
// });

// export default axiosInstance;